import React from 'react';
import { getEarning, getPracticeEarning } from 'api/provider';

const useEarningAmount = (timeRangeMonths?: number, isPractice = false): [number | undefined, boolean] => {
    const [loading, setLoading] = React.useState(false);
    const [amount, setAmount] = React.useState<number | undefined>(undefined);

    React.useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                setLoading(true);
                const request = isPractice ? getPracticeEarning : getEarning;
                const res = await request({ timeRangeMonths });
                if (!res.error && mounted) {
                    setAmount(res?.data?.data ?? undefined);
                }
            } catch (e) {
                console.error(e);
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        return () => {
            mounted = false;
        };
    }, [timeRangeMonths, isPractice]);

    return [amount, loading];
};

export default useEarningAmount;
